import { AvailableLocale, DEFAULT_LOCALE, isLocale } from "locales";
import { getNumberFormatter } from "./number-format-cache";

export function numberFormat(
    n: number,
    noOfDecimals: number = 0,
    locale: AvailableLocale
) {
    // Defensive runtime check: even though `locale` is typed as
    // AvailableLocale, callers that bypass type-checking (e.g. `as any`
    // casts, or plain-JS callers) could still pass an unsupported value.
    if (!isLocale(locale)) {
        locale = DEFAULT_LOCALE;
    }

    const numberFormatter = getNumberFormatter(
        `numberFormat:${locale}:${noOfDecimals}`,
        () =>
            new Intl.NumberFormat(locale, {
                minimumFractionDigits: noOfDecimals,
                maximumFractionDigits: noOfDecimals,
            })
    );
    return numberFormatter.format(n);
}
